// from: /Resources/Private/Layouts/Page/Default.html
const pathsElement = document.getElementById('js-paths');
const cssPath = pathsElement.dataset.css;


const initTeasersSlider = () => {

    const teasersSlider = document.querySelectorAll('.swiper.sTeasers__container');
    
    if (teasersSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-teasersslider" */
            './Module/swiper-teasersslider.js'
        ).then(module => {
            module.initSwiper(teasersSlider);
        }).catch(err => {
            console.error('Error in teasersSlider module: ', err);
        });
    }
}

const initTestimonialsSlider = () => {

    const testimonialsSlider = document.querySelectorAll('.swiper.testimonials__inner');
    
    if (testimonialsSlider[0]) {
        import(
            /* webpackChunkName: "webpack-swiper-teasersslider" */
            './Module/swiper-testimonialsslider.js'
        ).then(module => {
            module.initSwiper(testimonialsSlider);
        }).catch(err => {
            console.error('Error in testimonialsSlider module: ', err);
        });
    }
}


const initAccordions = () => {

    const accordionSelector = '.js-accordion';
  
    if (document.querySelector(accordionSelector)) {

        import(
            /* webpackChunkName: "webpack-accordions" */
            './Module/accordions.js'
        ).then(module => {
            module.initAccordion(accordionSelector);
        }).catch(err => {
            console.error('Error in accordion module: ', err);
        });
    }
};


const initBenefits = () => {

    const benefits = document.querySelectorAll('.benefits')

    if (benefits[0]) {

        benefits.forEach((benefit) => {

            const buttons  = benefit.querySelectorAll('.benefits__button');
            const contents = benefit.querySelectorAll('.js-content');
            
            buttons.forEach((button, i) => {

                button.addEventListener('click', () => {

                    contents.forEach((content) => {
                        content.classList.remove('js-active');

                        if (content.dataset.index == i) {
                            content.classList.add('js-active')
                        }
                    })          
                })  
            })  
        })
    }
};


const initVideos = () => {

    const videoWrappers = document.querySelectorAll('.video');
    
    if (videoWrappers[0]) {

        videoWrappers.forEach((videoWrap) => {

            const video       = videoWrap.querySelector('video');
            const button      = videoWrap.querySelector('.video__posterButton');
            const posterImage = videoWrap.querySelector('.video__poster');
            
            if(!button || !posterImage) return;

            button.addEventListener('click', () => {
                video.play();
                if (posterImage) posterImage.style.opacity = '0';
            })  
        })
    }
}

const initMenu = () => {

    import(
        /* webpackChunkName: "webpack-menu" */
        './Module/menu.js'
    ).then(module => {
        module.initMenu();
    }).catch(err => {
        console.error('Error in menu module: ', err);
    });
};


const initFocus = () => {

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
            document.body.classList.remove('js-hideOutline');
        }
    });

    document.addEventListener('mousedown', function() {
        document.body.classList.add('js-hideOutline');
    });
};


const initBanner = () => {

    const bannerClose = document.querySelector('.banner__close');
    
    if (bannerClose) {

        const banner = bannerClose.closest('.banner');

        bannerClose.addEventListener('click', (e) => {
            banner.classList.add('hidden');
        })
    }
};


const initMasonryTeasers = () => {

    const teasers = document.querySelector('.mTeasers__inner');
    
    if (teasers) {
        const msnry = new Masonry( teasers, {
            itemSelector: '.mTeasers__item',
            columnWidth: '.mTeasers__item',
            gutter: '.mTeasers__gutterSizer',
            percentPosition: true
        });
    }
}


const initLanguageMenu = () => {

    const languageMenu = document.querySelector('.navLanguage');
    
    if (languageMenu) {

        const button  = languageMenu.querySelector('.navLanguage__active');
        const options = languageMenu.querySelector('.navLanguage__list');

        button.addEventListener('click', (e) => {
            options.classList.toggle('js-open');
        })
    }
};

const initIntersectionObserver = () => {

    const itemSelector = '.frame';

    if (document.querySelector(itemSelector)) {
        
        import(
            './Module/intersection-observer.js'
        ).then(module => {
            module.initObserver(itemSelector);
        }).catch(err => {
            console.error('Error in intersection-observer module: ', err);
        });
    }
};


const tracking = (event, title) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': event,
        'title': title
    });
}


const trackingLanguage = () => {

    const buttons = document.querySelectorAll('.navLanguage__language a');
    const trackingEvent   = 'Sprache_auswaehlen';

    buttons.forEach((element) => {
        element.addEventListener('click', (event) => {
            const text = event.target.innerHTML;
            tracking(trackingEvent, text);
        });
    });
}


document.addEventListener("DOMContentLoaded", () => {
    initTeasersSlider();
    initTestimonialsSlider();
    initAccordions();
    initBenefits();
    initVideos();
    initMenu();  
    initFocus();
    initBanner();
    initMasonryTeasers();
    initLanguageMenu();
    initIntersectionObserver();
    trackingLanguage();
});




